import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { DataQueryContextState } from '../types';

export const initialDataQueryState: DataQueryContextState = {
  effectiveDateOptions: [],
  handleUpdateLinks: noop,
  isLoading: true,
  links: [],
  refetch: noop,
};

export const DataQueryContext = createContext(initialDataQueryState);

export const useDataQueryContext = () => useContext(DataQueryContext);
